import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LinearProgress from '@material-ui/core/LinearProgress';

interface Props {
  value: number;
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: 9,
    backgroundColor: 'transparent',
  },
  bar: {
    borderRadius: 3,
    backgroundImage: `linear-gradient(to right, 
      ${theme.extraColors.progressLeft},
      ${theme.extraColors.progressRight}
    )`,
  },
}));

const Progress: React.FC<Props> = ({ value }) => {
  const classes = useStyles();
  return <LinearProgress classes={classes} variant="determinate" value={value} />;
};

export default Progress;
